import { useQuery } from '@hooks/reactQuery';

import { getRUConfigurations } from '@api/ruConfigurations';

import { extractQueryParams } from '@utils/common';

import { IRUConfigurationsDTO } from '@interfaces/cmModule/dto/ruConfigurationsDTO';
import { IRUConfiguration } from '@interfaces/cmModule/ruConfiguration';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_CONFIGURATIONS } from '@constants/queryKeys';

interface IUseQueryRUConfigurationsReturned {
	ruConfigurations: IRUConfiguration[];
	countOfRecords: number;
	isLoadingRUConfigurations: boolean;
}

export const useQueryRUConfigurations = (params: IRUConfigurationsDTO): IUseQueryRUConfigurationsReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [RU_CONFIGURATIONS, params],
		queryFn: extractQueryParams(getRUConfigurations),
		enabled: [!!params.page && !!params.pageSize],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		ruConfigurations: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingRUConfigurations: (data && isLoading) || isFetching,
	};
};
